<template>
  <footer class="container">
    <div class="footer flex-space-between">
      <div class="flex-align-center">
        <CommonPing> </CommonPing>
        <p class="footer-copyright flex-start">
          {{ $t("layout.footer.copyright") }}
        </p>
      </div>

      <div class="footer-link flex-center">
        <div
          class="footer-link-item"
          v-for="item of COMMUNITY"
          :key="item.name"
        >
          <a
            :href="item.link"
            class="footer-link-item-a"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i :class="`icon icon-social-footer-${item.icon}`"></i>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapState } from "vuex";
import CommonPing from "@/components/Common/ping.vue";

export default {
  name: "Footer",
  components: { CommonPing },
  computed: {
    ...mapState(["COMMUNITY"]),
  },
};
</script>
<style scoped lang="scss">
footer {
  height: 30px;
  background: #000000;
  position: sticky;
  bottom: 0;
  z-index: 1008;

  .footer {
    height: 100%;
    padding: 0 32px;
  }

  .footer-copyright {
    border-left: 1px solid rgba(255, 255, 255, 0.1);
    padding-left: 24px;
    line-height: 30px;
    font-size: 12px;
    height: 100%;
    color: colorRgba($lighten-color, 0.3);
  }
  .footer-link-item {
    transition: opacity 0.3s;
    cursor: pointer;
    z-index: 1;
    opacity: 0.2;

    &:hover {
      opacity: 1;
    }
    & + .footer-link-item {
      margin-left: 32px;
    }
    .footer-link-item-a {
      width: 100%;
      display: flex;
      align-items: center;
    }
  }
}
</style>
